import Tool, { type ToolArgs } from '../../../tools/Tool';
import React, { useState, useRef } from 'react';
import { Transforms } from 'slate';
import { ReactEditor } from 'slate-react';
import styles from '../../../components/Toolbar/Toolbar.module.css';
import classNames from 'classnames';
import { isMediaElement } from '../../../types/guards';
import useFocusElementToolbarInput from '../../../components/ElementToolbar/useFocusElementToolbarInput';

const EditAltModal = ({ editor, element, toolbarHideModal }: ToolArgs) => {
  const defaultValue =
    element && isMediaElement(element) ? element.media_alt ?? '' : '';
  const [originalValue] = useState(defaultValue);
  const [value, setValue] = useState(defaultValue);
  const inputRef = useRef<HTMLInputElement>(null);

  useFocusElementToolbarInput(inputRef);

  if (!element) return <></>;

  const path = ReactEditor.findPath(editor, element);

  const updateMediaElement = (alt: string) => {
    Transforms.setNodes(
      editor,
      { media_alt: alt },
      {
        at: path,
      }
    );
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    switch (event.key) {
      case 'Enter':
      case 'Tab':
        toolbarHideModal?.();
        event.preventDefault();
        updateMediaElement(value);
        break;
      case 'Escape':
        toolbarHideModal?.();
        event.preventDefault();
        updateMediaElement(originalValue);
        break;
    }
  };

  const handleBlur = () => {
    updateMediaElement(value);
  };

  return (
    <div>
      <input
        type="text"
        ref={inputRef}
        className={classNames('unstyled-input', styles.toolbarInput)}
        placeholder="Alt text"
        value={value}
        onChange={(event) => setValue(event.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
      />
    </div>
  );
};

// Edit the alt attribute.
class ToolEditAlt extends Tool {
  static toolName = 'Edit alt text';
  static iconClass = 'fa-regular fa-a';
  static withoutRefocus = true;

  // Show the modal view to editor the URL.
  static action({ editor, element, toolbarShowModal }: ToolArgs): void {
    toolbarShowModal?.(ToolEditAlt);
  }

  static renderToolbarButtonIcon({ element }: ToolArgs) {
    let doneIcon;
    if (
      element &&
      isMediaElement(element) &&
      element.media_alt &&
      element.media_alt.trim().length > 0
    ) {
      doneIcon = <i className="far fa-circle-check"></i>;
    }

    return <span className={styles.toolbarButtonText}>{doneIcon} Alt</span>;
  }

  static renderToolbarModal(toolArgs: ToolArgs) {
    return EditAltModal(toolArgs);
  }

  static handleModalClosed({ editor, element }: ToolArgs) {}
}

export default ToolEditAlt;
